import * as React from 'react'

import {
  InitialParentSignUpForm,
  InitialParentSignUpFormSSO,
} from 'main/components/common/AuthModal'
import { CredentialsFields } from 'main/gql/credentials'
import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'
import { UserSignUpSource } from 'main/util/user'

import { SchoolContainer, SchoolType } from '../../types'
import { getFormSubmitButtonCta, getSubtext } from '../Login'

interface IProps {
  schoolContainer: SchoolContainer
  onRequestLogin: () => void
  onComplete: (credentials: CredentialsFields) => void
}

export default function SignUp(props: IProps) {
  const { schoolContainer, onRequestLogin, onComplete } = props

  const ssoFlag = useFeatureFlag(Flags.SSO)
  const isSSO = ssoFlag.enabled()

  if (isSSO) {
    return (
      <InitialParentSignUpFormSSO
        googleOptimize={googleOptimize()}
        subtext={getSubtext(schoolContainer)}
        source={getSignUpSource(schoolContainer)}
        segmentData={{
          event: 'New Parent Lead',
          data: makeTrackingData(schoolContainer),
        }}
      />
    )
  } else {
    return (
      <InitialParentSignUpForm
        cta={getFormSubmitButtonCta(schoolContainer)}
        googleOptimize={googleOptimize()}
        source={getSignUpSource(schoolContainer)}
        subtext={getSubtext(schoolContainer)}
        trackingData={makeTrackingData(schoolContainer)}
        onComplete={onComplete}
        onRequestLogin={onRequestLogin}
      />
    )
  }
}

function googleOptimize() {
  return {
    submitButton: 'contactSchoolSignUpSubmitButton',
    subtext: 'contactSchoolSignUpSubtext',
  }
}

function makeTrackingData(schoolContainer: SchoolContainer) {
  switch (schoolContainer.__type) {
    case SchoolType.Internal:
      return { schoolId: schoolContainer.school.id }
    case SchoolType.External:
      return { externalSchoolId: schoolContainer.externalSchool.id }
  }
}

function getSignUpSource(schoolContainer: SchoolContainer) {
  switch (schoolContainer.__type) {
    case SchoolType.Internal:
      return UserSignUpSource.ParentContactModal
    case SchoolType.External:
      return UserSignUpSource.ParentExternalSchoolRequestInfoModal
  }
}
